import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';

export const SyncFullMexGlobalFilterOperations = (section:string |null) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `mex-global-filter/sync-full/${section}`,
    {
      headers,
    }
  );
};
